import type { StudioBinding, StudioCatalog, StudioDataset } from 'src/components/star-grid/reportStudio.types';
import type { PnlDimensionGroup } from 'src/components/star-grid/pnlDimension.types';
import { withDiscoveredStudioBindings } from 'src/components/star-grid/utils/studioDiscoveredBindings';

/** The id a binding's member tree loads under: its tree, else the binding itself when a rollup or member list supplies one. */
export const studioBindingTreeId = (binding: StudioBinding): string | undefined =>
  binding.tree_id ?? (binding.rollup || binding.members_path ? binding.id : undefined);
export const isStudioBindingSelectable = (dataset: StudioDataset, id: string): boolean =>
  dataset.selectable_binding_ids === undefined || dataset.selectable_binding_ids.includes(id);
export const selectableStudioBindings = (dataset: StudioDataset) =>
  dataset.bindings.filter((binding) => isStudioBindingSelectable(dataset, binding.id));
export const studioDimensionBindings = (dataset: StudioDataset, bindingId: string) => {
  const binding = dataset.bindings.find((item) => item.id === bindingId);
  const aliases = new Set([
    bindingId,
    ...dataset.bindings.filter((item) => binding?.tree_id && item.tree_id === binding.tree_id).map((item) => item.id)
  ]);
  const dimension = dataset.dimensions?.find((item) => item.binding_ids.some((id) => aliases.has(id)));
  return selectableStudioBindings(dataset).filter((item) =>
    dimension ? dimension.binding_ids.includes(item.id) : item.dimension === binding?.dimension
  );
};
export const withSelectableStudioBindings = (catalog: StudioCatalog, groups: readonly PnlDimensionGroup[]): StudioCatalog => ({
  ...catalog,
  datasets: catalog.datasets.map((dataset) => withDiscoveredStudioBindings(dataset, groups))
});
